import { Box, Typography } from "@mui/material";
import { PinnedViewsSelector } from "./pinned_views_selector";
import { ShowSettings } from "./show_run_settings/container";
import { Download } from "./download_component";
import { SetChartView } from "./set_chart_view_component";
import { PivotControl } from "../../../constants/pivot_control_options";

export const ControlsHeader = ({
  title,
  isLoading,
  showControls,
  params,
  setParams,
  datasetName,
  transformId,
  handleDownload,
  isChartView,
  setIsChartView,
}: {
  title: string;
  isLoading: boolean;
  showControls: any[];
  params: any;
  setParams: (params: any) => void;
  datasetName: string;
  transformId: string;
  handleDownload: () => void;
  isChartView?: boolean;
  setIsChartView?: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: 0,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography variant="h1" sx={{ pl: 1 }}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {showControls.includes(PivotControl.StoreAsDefault) && (
        <PinnedViewsSelector
          isLoading={isLoading}
          params={params}
          setParams={setParams}
          datasetName={datasetName}
          transformId={transformId}
        />
      )}
      {showControls.includes(PivotControl.EnableChartView) &&
        isChartView !== undefined &&
        setIsChartView && (
          <SetChartView
            isChartView={isChartView}
            setIsChartView={setIsChartView}
            isLoading={isLoading}
          />
        )}
      {showControls.includes(PivotControl.ShowSettings) && (
        <ShowSettings isLoading={isLoading} />
      )}
      {showControls.includes(PivotControl.Download) && (
        <Download isLoading={isLoading} onClick={handleDownload} />
      )}
    </Box>
  </Box>
);
